import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const upsertFinishSpecs = async (
	productId: number,
	fields: Record<string, unknown>,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductId", value: productId }];

	for (const [field, value] of Object.entries(fields)) {
		parameters.push({
			name: field,
			value: value as string | number | boolean | null,
		});
	}

	return await apiService.callV2("[FAB].[UpsertFinishSpecs]", parameters);
};
